import type { CityConfig } from "../city-template/types";

export const hamptonVaConfig: CityConfig = {
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options for Hampton and Virginia Peninsula residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Hampton Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.hampton.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Hampton Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.hampton.gov/" },
  ],
  city: "Hampton",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "hampton-va",
  route: "/cities/hampton-va",
  title: "Emergency Passport Hampton, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hampton, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Hampton, Langley AFB, and the Virginia Peninsula. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Hampton, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Hampton, Langley AFB, or the Virginia Peninsula? We help Hampton travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hampton%20Virginia%20waterfront%20with%20the%20historic%20Hampton%20Roads%20harbor%2C%20the%20Virginia%20Air%20and%20Space%20Center%20visible%2C%20Fort%20Monroe%20in%20the%20distance%2C%20the%20Hampton%20River%20and%20Chesapeake%20Bay%20shoreline%2C%20modern%20city%20skyline%20with%20historic%20coastal%20architecture%2C%20warm%20sunset%20light%20over%20the%20Virginia%20Peninsula%20with%20naval%20ships%20and%20sailboats%2C%20professional%20photography%20showcasing%20Hampton%20Roads%20coastal%20city%20with%20military%20heritage%20and%20waterfront%20charm%2C%20no%20people%20visible%2C%20scenic%20harbor%20landscape&width=1800&height=700&seq=hampton-va-hero-001&orientation=landscape",
  heroImageAlt: "Hampton Virginia waterfront with Fort Monroe, the Virginia Air and Space Center, and the Chesapeake Bay shoreline",
  geoPosition: "37.0299;-76.3452",
  geoPlacename: "Hampton, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 200 miles north of Hampton via I-95",
  },
  nearbyCitiesZips: [
    { name: "Hampton", zips: "23630, 23651, 23661, 23663, 23664, 23665, 23666, 23667, 23668, 23669, 23670, 23681" },
    { name: "Newport News", zips: "23601, 23602, 23603, 23605, 23606, 23607, 23608, 23609, 23612, 23628, 23630, 23661, 23662, 23663, 23664, 23665, 23666, 23668, 23669, 23681, 23693" },
    { name: "Poquoson", zips: "23662" },
    { name: "York County", zips: "23690, 23691, 23692, 23693" },
    { name: "Williamsburg", zips: "23185, 23186, 23187, 23188" },
    { name: "Norfolk", zips: "23501, 23502, 23503, 23504, 23505, 23506, 23507, 23508, 23509, 23510, 23511, 23513, 23514, 23515, 23517, 23518, 23519, 23520, 23523, 23529, 23541, 23551" },
    { name: "Virginia Beach", zips: "23450, 23451, 23452, 23453, 23454, 23455, 23456, 23457, 23458, 23459, 23460, 23461, 23462, 23463, 23464, 23465, 23466, 23467, 23468, 23471, 23479" },
    { name: "Chesapeake", zips: "23320, 23321, 23322, 23323, 23324, 23325, 23326, 23327, 23328" },
    { name: "Portsmouth", zips: "23701, 23702, 23703, 23704, 23705, 23707, 23708, 23709" },
    { name: "Suffolk", zips: "23432, 23433, 23434, 23435, 23436, 23437, 23438, 23439" },
    { name: "Smithfield", zips: "23430, 23431" },
    { name: "Gloucester", zips: "23061, 23062, 23072" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Virginia Peninsula" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Virginia Peninsula Hub", desc: "Serving Hampton, Newport News, Langley AFB, and Poquoson" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Newport News VA passport services", route: "/cities/newport-news-va" },
    { name: "Virginia Beach passport services", route: "/cities/virginia-beach" },
    { name: "Norfolk VA passport services", route: "/cities/norfolk-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hampton remotely via secure courier. We do not have a walk-in office in Hampton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hampton and Virginia Peninsula travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Hampton and the Virginia Peninsula including Newport News, Langley AFB, Poquoson, and York County",
  serviceAreaIntro: "From the historic waterfront of downtown Hampton to the military community of Langley AFB, from the quiet neighborhoods of Wythe and Buckroe to the growing corridors of Hampton Roads, from the shores of the Chesapeake Bay to the borders of Newport News, from the quaint town of Poquoson to the colonial charm of Williamsburg — Fast Passport Center serves every corner of Hampton and the Virginia Peninsula. We regularly help travelers from Langley AFB, Newport News, and York County get their passports fast.",
  nearbyCitiesIntro: "We serve all Hampton neighborhoods and the Virginia Peninsula including Newport News, Langley AFB, Poquoson, York County, and Williamsburg.",
  howItWorksIntro: "Most Hampton travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Hampton travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Hampton and Virginia Peninsula travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hampton? Here are the most common ones we hear from Virginia Peninsula travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hampton international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michelle D.",
      location: "Hampton, VA",
      rating: 5,
      text: "I live near Fort Monroe and needed an emergency passport for a family trip to Italy with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Mercury Boulevard and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Robert K.",
      location: "Langley AFB, VA",
      rating: 5,
      text: "As a Langley AFB service member, I needed an expedited passport for a deployment. Fast Passport Center made it incredibly easy. Everything was done online, and my passport was back in 4 days. The convenience for military families on the Peninsula is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Linda S.",
      location: "Hampton, VA",
      rating: 5,
      text: "First passports for my twin boys before a family trip to Puerto Rico. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 5 days. For Hampton families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "James B.",
      location: "Newport News, VA",
      rating: 5,
      text: "Lost my passport 2 days before a business trip to London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 24 hours. They saved my business trip. Virginia Peninsula professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "hampton-va-1",
      name: "Hampton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Hampton",
      state: "VA",
      zip: "23669",
      phone: "(757) 727-8311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hampton facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-va-2",
      name: "Newport News Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Newport News",
      state: "VA",
      zip: "23601",
      phone: "(757) 596-7351",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Newport News, north of Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Newport News and the Peninsula. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-va-3",
      name: "Langley AFB Post Office",
      type: "Military Post Office",
      address: "Street address pending USPS listing",
      city: "Hampton",
      state: "VA",
      zip: "23665",
      phone: "(757) 764-3646",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Langley AFB, Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves military personnel and families at Langley AFB. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-va-4",
      name: "Williamsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Williamsburg",
      state: "VA",
      zip: "23185",
      phone: "(757) 229-3311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Williamsburg, west of Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Williamsburg and the Historic Triangle. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-va-5",
      name: "Hampton City Clerk",
      type: "City Clerk",
      address: "22 Lincoln St",
      city: "Hampton",
      state: "VA",
      zip: "23669",
      phone: "(757) 727-6375",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Hampton City",
      website: "https://www.hampton.gov",
      websiteLabel: "Hampton City Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "hampton-va-6",
      name: "Hampton University",
      type: "Campus Resource",
      address: "100 E Queen St",
      city: "Hampton",
      state: "VA",
      zip: "23668",
      phone: "(757) 727-5000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Hampton, near Hampton University",
      website: "https://www.hamptonu.edu",
      websiteLabel: "Hampton University",
      notes: "Not a passport acceptance facility, but helpful for students and international program participants. Check with student services.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hampton photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Virginia Peninsula acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hampton applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hampton families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hampton travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hampton or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hampton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hampton before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Hampton for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Virginia Peninsula." },
    { q: "How fast can I renew my passport in Hampton?", a: "Fast Passport Center offers fast passport renewal in Hampton in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Hampton?", a: "The nearest regional passport agency to Hampton is the Washington Passport Agency, located approximately 200 miles north in downtown Washington, DC via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Hampton." },
    { q: "Can I get a same-day passport appointment near Hampton?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Hampton residents." },
    { q: "Can I expedite a child passport in Hampton?", a: "Yes. Fast Passport Center expedites child passports in Hampton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hampton and Virginia Peninsula families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hampton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Hampton?", a: "With Fast Passport Center's emergency courier service, Hampton travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Hampton?", a: "Popular options include the Hampton Main Post Office (23669), Newport News Post Office (23601), Langley AFB Post Office (23665), and Williamsburg Post Office (23185). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live at Langley AFB or in Newport News?", a: "We serve the entire Virginia Peninsula including Langley AFB, Newport News, Poquoson, and York County. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed. Military families at Langley AFB are especially well served with our fast processing." },
    { q: "How much does expedited passport service cost in Hampton?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hampton", address: "1127 W Mercury Blvd, Hampton, VA 23666", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Hampton", address: "2003 W Mercury Blvd, Hampton, VA 23666", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "CVS Pharmacy — Newport News", address: "12128 Jefferson Ave, Newport News, VA 23602", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Newport News", address: "12647 Jefferson Ave, Newport News, VA 23602", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "CVS Pharmacy — Williamsburg", address: "1520 Richmond Rd, Williamsburg, VA 23185", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Norfolk", address: "7400 Granby St, Norfolk, VA 23505", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/store-locator" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Hampton",
      address: "8109 Roanoke Ave, Hampton, VA 23661",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Newport News",
      address: "12730 Patrick Henry Dr, Newport News, VA 23602",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Williamsburg",
      address: "5125 John Tyler Hwy, Williamsburg, VA 23188",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves the Historic Triangle. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Located approximately 20 miles south of Hampton",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "The closest international airport to Hampton. International and domestic flights. Accessible via I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: true,
    },
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Located approximately 15 miles west of Hampton",
      address: "1000 Bland Blvd, Newport News, VA 23602",
      note: "Regional hub for the Virginia Peninsula. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Located approximately 70 miles northwest of Hampton",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via I-64 and I-295.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
  ],
};